import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { Formation } from "types";
import type { RootState } from "../store";

// Define a type for the slice state
interface CurrentFormationState {
  currFormation: Formation;
}

// Define the initial state using that type
const initialState: CurrentFormationState = {
  currFormation: {
    addedOn: null,
    description: "",
    id: 0,
    image: "",
    lastModifiedOn: null,
    stagiarePrice: 0,
    professionalPrice: 0,
    title: "",
    isVerified: false,
  },
};

export const currentFormationSlice = createSlice({
  name: "currentFormation",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    // Use the PayloadAction type to declare the contents of `action.payload`
    setCurrentFormation: (state, action: PayloadAction<Formation>) => {
      state.currFormation = action.payload;
    },
  },
});

export const { setCurrentFormation } = currentFormationSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const selectCurrentFormation = (state: RootState) =>
  state.currentFormation;
export default currentFormationSlice.reducer;
